import { AccessDeniedError, UnexpectedError } from "../../domain/errors";
import { DuplicatedNfError } from "../../domain/errors/duplicated-nf-error";
import { UnauthorizedError } from "../../domain/errors/unauthorized-error";
import { DeleteCargo } from "../../domain/usecases/delete-cargo";
import { HttpClient, HttpStatusCode } from "../protocols/http";

export class DbDeleteCargo implements DeleteCargo {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient
  ) {}

  async delete(id: number): Promise<boolean> {
    const res = await this.httpClient.request({
      url: this.url,
      method: "delete",
      body: { id },
    });

    switch (res.statusCode) {
      case HttpStatusCode.ok:
        return true;
      case HttpStatusCode.forbidden:
        throw new AccessDeniedError();
      case HttpStatusCode.unauthorized:
        throw new UnauthorizedError();
      case HttpStatusCode.badRequest:
        throw new DuplicatedNfError(res.body.error.data);
      default:
        throw new UnexpectedError();
    }
  }
}
